import React, { useState } from "react";
import TestimonialData from "main/components/componentsHelper/Landgingpage/TestimonialData";
import TestimonialData2 from "main/components/componentsHelper/Landgingpage/TestimonialData2";
import TestimonialData3 from "main/components/componentsHelper/Landgingpage/TestimonialData3";
import arrow from "main/assets/images/Images/Home-Images/arrow.png";
import arrowleftred from "main/assets/images/Images/Home-Images/arrow-left-red.svg";

type Props = {};
const data: any[] = [TestimonialData, TestimonialData2, TestimonialData3];
const Testimonials = (props: Props) => {
  const [activetIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };
  const goToSlideArrow = (index: number) => {
    if (index && activetIndex === data.length - 1) {
      setActiveIndex(0);
    } else if (index) {
      setActiveIndex(activetIndex + 1);
    } else if (activetIndex === 0) {
      setActiveIndex(data.length - 1);
    } else {
      setActiveIndex(activetIndex - 1);
    }
  };
  const [enter, setEnter] = useState(false);
  const MouseEnter = () => {
    setEnter(true);
  };
  const MouseLeave = () => {
    setEnter(false);
  };

  return (
    <div className="pb-40">
      {data.map((val, index) => (
        <React.Fragment key={index}>
          {activetIndex === index && val()}
        </React.Fragment>
      ))}
      <div className="d-flex flex-row justify-content-center flex-gap-10 position-relative topx-30 mb-20">
        {data.length > 1 &&
          data.map((val, index) => (
            <>
              <div
                key={index}
                onClick={() => goToSlideArrow(index)}
                onMouseEnter={MouseEnter}
                onMouseLeave={MouseLeave}
              >
                {" "}
                <img
                  src={enter ? arrowleftred : arrow}
                  className={`position-absolute left-60 z-index-100 top-n-2320 d-none d-lg-block ${
                    index &&
                    "rotate-180 top-n-2200 rotate-180 leftp-90 top-n-2200 bottom-n-18 d-none d-lg-block"
                  }`}
                  alt="background will be here"
                />
              </div>
              <button
                key={index}
                className={
                  index === activetIndex ? "active p-1" : "banner-slider p-1"
                }
                onClick={() => goToSlide(index)}
              ></button>
            </>
          ))}
      </div>
    </div>
  );
};

export default Testimonials;
